//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../Features/Features.SheetMetal.SheetmetalBaseBuilder.js";
import "../no/Expression.js";
import "../no/ugmath.js";
import "../no/Features.js";
import "../no/Expression.js";
let d=[[[0,"AutoReliefType",1,0],[0,"BendDivideParameter",1,0],[0,"BendOptions",0,"Features.SheetMetal.BendOptions",0],[0,"BendingMethod",1,0],[0,"EndSection",1,"Section",0],[0,"EndSectionPoint",1,0],[0,"EndSketch",1,"Features.SketchFeature",0],[1,"IndexMarkLength",0,"Expression",0],[0,"IsSecondary",1,0],[1,"MaximumChordHeight",0,"Expression",0],[1,"MaximumSegmentAngle",0,"Expression",0],[1,"MaximumSegmentLength",0,"Expression",0],[0,"NumberOfBendSegments",1,0],[0,"StartSection",1,"Section",0],[0,"StartSectionPoint",1,0],[0,"StartSketch",1,"Features.SketchFeature",0],[0,"ThicknessSide",1,0],[0,"TrimEndPlates",1,0],[0,"UseSegmentedBends",1,0]],[[[],"GetThickness",{R_:{thickness:"Expression"}},0,0],[[],"ValidateBuilderData",{R_:{builder_data_validity:''}},0,0]],[]];
SPLM.Features.SheetMetal.LoftedFlangeBuilder = class extends SPLM.Features.SheetMetal.SheetmetalBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.LoftedFlangeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SheetMetal.LoftedFlangeBuilder.SectionSideOptions = Object.freeze({
    "Left" : "Left", "Right" : "Right"});

SPLM.Features.SheetMetal.LoftedFlangeBuilder.BendingMethods = Object.freeze({
    "Formed" : "Formed", "Advanced" : "Advanced", "Bends" : "Bends"});

SPLM.Features.SheetMetal.LoftedFlangeBuilder.AutoReliefTypes = Object.freeze({
    "Linear" : "Linear", "Spherical" : "Spherical"});

SPLM.Features.SheetMetal.LoftedFlangeBuilder.BendDivideParameters = Object.freeze({
    "NumberOfBendSegments" : "NumberOfBendSegments", "MaximumChordHeight" : "MaximumChordHeight", "MaximumSegmentLength" : "MaximumSegmentLength", "MaximumSegmentAngle" : "MaximumSegmentAngle"});

export default SPLM;